export const theme = {
  colors: {
    background: "#FAF7F4",
    backgroundAlt: "#F3EDE6",
    white: "#FFFFFF",
    brown: "#3D2B1F",
    brownLight: "#5C4033",
    brownMuted: "#8A7568",
    tan: "#E8DFD4",
    tanDark: "#D4C4B0",
    accent: "#C4956A",
    text: "#6B5E54",
    textLight: "#9A8E84",
    border: "#E5DDD4",
    button: "#111111",
    buttonHover: "#333333",
  },
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body: "'DM Sans', 'Motiva Sans Light', sans-serif",
  },
  radius: {
    pill: "999px",
    lg: "24px",
    md: "16px",
    sm: "12px",
  },
  shadow: {
    soft: "0 8px 32px rgba(61, 43, 31, 0.08)",
    card: "0 4px 20px rgba(61, 43, 31, 0.06)",
  },
  layout: {
    maxWidth: "1200px",
    paddingX: "60px",
    paddingXTablet: "40px",
    paddingXMobile: "24px",
  },
};
